var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex flex-column",attrs:{"outlined":""}},[_c('StockMidBulkFile'),_c('StockMidBulkHistory')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }